require('../scss/payment-card.scss');

export default {
    name: 'payment-card',

    template: `
        <div class="payment-card">
            <div class="card-number">{{ cardNumber }}</div>
            <div class="card-bottom">
                <div class="card-state" :class="{ selected: selected }">
                    <span v-if="selected">
                        <img svg-inline :src="greenTickIcon" class="w-100">
                    </span>
                </div>
                <div v-if="type !== null" class="card-logo">
                    <img svg-inline :src="cardLogos[type]">
                </div>
            </div>
        </div>
    `,

    data() {
        return {
            cardLogos: {
                'Visa': require('../../../images/svgs/cards/Visa.svg'),
                'Maestro': require('../../../images/svgs/cards/Maestro.svg'),
                'MasterCard': require('../../../images/svgs/cards/MasterCard.svg'),
                'American Express': require('../../../images/svgs/cards/American Express.svg'),
            },
            'greenTickIcon': require('../../../images/svgs/green-tick.svg'),
        };
    },
    props: {
        cardNumber: {
            type: String,
            required: true,
        },
        selected: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: null,
        },
    },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/Components/shared/Billing/PaymentCard.js